// See https://en.wikipedia.org/wiki/Interval_(mathematics)#Including_or_excluding_endpoints
// Used for defining whether the start/end of an interval is included in a range based calculation
export enum Inclusivity {
  Open, // (a, b)
  OpenClosed, // (a, b]
  ClosedOpen, // [a, b)
  Closed, // [a, b]
}
